import type { HeadToHeadSearch, TeamHistorySearch } from './search-schema'

import { queryOptions } from '@tanstack/react-query'

import { getHeadToHead, getHistoricalMatch, listTeamHistory } from './api'

const HISTORY_STALE_TIME_MS = 60_000

export const footballHistoryQueryKeys = {
  all: ['football-history'] as const,
  team: (teamId: string, search: TeamHistorySearch) => [
    ...footballHistoryQueryKeys.all,
    'team',
    teamId,
    search,
  ] as const,
  match: (historicalMatchId: string) => [
    ...footballHistoryQueryKeys.all,
    'match',
    historicalMatchId,
  ] as const,
  headToHead: (search: HeadToHeadSearch) => [
    ...footballHistoryQueryKeys.all,
    'head-to-head',
    search,
  ] as const,
}

export function teamHistoryQueryOptions(teamId: string, search: TeamHistorySearch) {
  return queryOptions({
    queryKey: footballHistoryQueryKeys.team(teamId, search),
    queryFn: () => listTeamHistory(teamId, search),
    staleTime: HISTORY_STALE_TIME_MS,
  })
}

export function historicalMatchQueryOptions(historicalMatchId: string) {
  return queryOptions({
    queryKey: footballHistoryQueryKeys.match(historicalMatchId),
    queryFn: () => getHistoricalMatch(historicalMatchId),
    staleTime: HISTORY_STALE_TIME_MS,
  })
}

export function headToHeadQueryOptions(search: HeadToHeadSearch) {
  return queryOptions({
    queryKey: footballHistoryQueryKeys.headToHead(search),
    queryFn: () => getHeadToHead(search),
    staleTime: HISTORY_STALE_TIME_MS,
  })
}
